export const getBusinessEntityTypeName = (
  businessEntityType?:
    | "llp"
    | "soleTrader"
    | "limited"
    | "partnership"
    | "notRegistered"
    | "other",
): string => {
  switch (businessEntityType) {
    case "llp":
      return "LLP";
    case "soleTrader":
      return "Sole Trader";
    case "limited":
      return "Limited";
    case "partnership":
      return "Partnership";
    case "notRegistered":
      return "Not Registered";
    case "other":
      return "Other";
    default:
      return "Unknown";
  }
};
